import React from 'react';
import Helmet from 'react-helmet';
import * as _ from 'lodash';
import ClipLoader from 'react-spinners/ClipLoader';
import { PartnerCompanyForm } from '../components/forms/PartnerCompany'; // フォーム
import { PartnerNaviList } from '../components/list/PartnerNaviList';
import { CompanyService } from '../services/Companies';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { HEADER_CONSTANTS } from '../utilities/constants';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import { safariOnIosCheck } from '../utilities/stringUtil';
import {
  getPartnerCompanyInfo,
  propsToCompanyId,
} from '../utilities/partnerCompanyConfirmUtil';
import { MasterPageHeader } from '../components/PageHeader';
import {
  FormList,
  FormListSubHeader,
} from '../components/CommonFormComponents';
import { CcusTitleBlock } from '../components/CcusFormComponent';

/**
 * 協力会社 会社情報 詳細 画面
 * 画面遷移
 *  1.  協力会社管理者 > 会社情報確認 > 基本情報
 *  2.  協力会社管理者 > 代行登録会社一覧 > 確認
 *  3.  協力会社管理者 > 通知(会社情報更新)
 *  ※ 代行登録会社一覧から開いた後に会社情報確認を開くとcomponentDidMountは発生せずにthis.props.view.state.idのみ変わる
 */
export class CompanyPreview extends React.Component {
  constructor(props) {
    super(props);

    // SessionStorage内の作業員新規作成・編集に使用した不要になったものを削除
    // SessionStorageService.removeItem('sessionSelectedPartnerCompanyId');
    // SessionStorageService.removeItem('sessionSelectedPartnerCompanyName');

    this.initSelectedCompany();

    this.state = {
      selectedCompanyName: '',
      roleId: LocalStorageService.getRoleId(),
      userId: LocalStorageService.getUserId(),
      isCommonHojin: false,
      formValues: {
        name: '', // 会社名
        kana: '', // 会社名かな
        juridical_personality_code: '', // 法人格
        company_number: '', // 法人番号
        one_master_flag: null, // 個人事業主フラグ
        postal_code: '', // 郵便番号
        prefectures_code_id: '', // 都道府県
        city_name: '', // 市区町村
        street_number: '', // 丁目・番地
        building_name: '', // 建物名・部屋番号
        tel: '', // 電話番号
        fax: '', // FAX
        company_icon_image_url: '', // 会社ロゴ
        joining_flag: SessionStorageService.getPartnerCompanyJoiningFlag(), // 元請固有フラグ
        ccus_jigyousya_id: '', //ccus事業者id
        update_username: '', // 更新ユーザー
        updated_at: '', // 更新日時
        company_branch: {
          // 支店情報
          name: '', // 支店名
          kana: '', // 支店名かな
        },
        one_owner_flag: null,
      },
      users: null,
      icon_image_url: '',
      isLoading: false,
      expirationCompany: {},
    };

    this.initForm = this.initForm.bind(this); // フォーム生成
    this.onClickEditButton = this.onClickEditButton.bind(this);
  }

  initSelectedCompany = () => {
    this.selectedCompanyId = propsToCompanyId(this.props);
    this.isOwnCompany =
      Number(
        SessionStorageService.getItem('sessionPartnerCompanyIdOfPrimeCompany')
      ) === this.selectedCompanyId;
  };

  getCompany = async () => {
    this.setState({
      isLoading: true,
    });

    const {
      result,
      company,
      companyName,
      icon_image_url,
      users,
      company_branch,
    } = await getPartnerCompanyInfo(this.selectedCompanyId);

    if (!result) {
      this.setState({
        isLoading: false,
      });
      return;
    }

    this.setState({
      selectedCompanyName: companyName,
      ccus_jigyousya_id: company.ccus_jigyousya_id,
      users,
      icon_image_url,
      isLoading: false,
    });
    this.initForm(company, company_branch);
  };

  getExpiration = async () => {
    await CompanyService.expirations(this.selectedCompanyId).then(response => {
      if (!response.result) {
        return;
      }
      this.setState({
        expirationCompany: {
          ...this.state.expirationCompany,
          ...response.data.entities.company.expiration,
        },
      });
    });
  };

  goBack = () => {
    _masterSlideLoader.show('AgencyCompanies', {
      state: {},
    });
  };

  componentDidMount() {
    this.getCompany();
    this.getExpiration();
  }

  componentDidUpdate(prevProps) {
    // 代行登録一覧から開いている状態で会社情報確認で遷移した場合
    if (!_.isEqual(prevProps.view.state.id, this.props.view.state.id)) {
      this.initSelectedCompany();
      this.getCompany();
      this.getExpiration();
    }
  }

  /**
   * フォーム生成
   * @param company {object} 会社情報
   * @param company_branch {object} 支店情報
   */
  initForm(company, company_branch) {
    const formValues = _.cloneDeep(this.state.formValues);
    const isCommonHojin = this.isCommonHojin(company);

    // 会社情報
    _.each(company, (company_data, index) => {
      if (_.has(formValues, index)) {
        if (index === 'one_owner_flag') {
          formValues[index] = company_data;
        } else {
          formValues[index] = _.defaultTo(company_data, '');
        }
      }
    });

    // 支店情報
    _.each(company_branch, (company_branch_data, index) => {
      if (_.has(formValues.company_branch, index)) {
        formValues.company_branch[index] = company_branch_data
          ? company_branch_data
          : '';
      }
    });

    // 支店情報
    if (_.isNaN(company_branch)) {
      formValues.company_branch.name = company_branch.name;
      formValues.company_branch.kana = company_branch.kana;
    }

    this.setState({
      formValues,
      isCommonHojin,
    });
  }

  isCommonHojin(company) {
    const { joining_flag, one_master_flag } = company;
    if (
      joining_flag === 1 &&
      (one_master_flag === null || one_master_flag === 0)
    ) {
      return true;
    } else {
      // console.log('共通協力会社である:', joining_flag === 1, joining_flag, '1人親方出ない。法人である:', one_master_flag === (null || 0), one_master_flag);
      return false;
    }
  }

  /**
   * 編集ボタンの押下
   *
   * @memberof CompanyPreview
   */
  onClickEditButton() {
    // 画面遷移前に選択中の会社名をsession storageに入れる
    SessionStorageService.setItem(
      'sessionSelectedPartnerCompanyId',
      this.selectedCompanyId
    );

    _masterSlideLoader.show('CompanyEdit', {
      state: {
        id: this.selectedCompanyId,
      },
    });
  }

  render() {
    let masterSlideViewBodyHeight = 'calc(100vh - 84px)';
    // ios-safariだとツールバー分の高さがある為、考慮する
    // 後々ブラッシュアップが必要
    if (safariOnIosCheck() === true) {
      masterSlideViewBodyHeight = 'calc(100vh - 115px)';
    }

    const { selectedCompanyName, isLoading } = this.state;

    const title = `${selectedCompanyName} 会社情報`;

    return (
      <div id='slide-view' className='contruction-slide-view show'>
        <Helmet>
          <title>
            {HEADER_CONSTANTS.title} - {title}
          </title>
        </Helmet>
        <div className='contruction-slide-view__view'>
          <MasterPageHeader
            title={title}
            loaderComponent={<ClipLoader size={20} color={'#EDB715'} />}
            loaded={!isLoading}
            onClose={() => _masterSlideLoader.close()}
          />
          <div
            className='contruction-slide-view__body'
            style={{ height: masterSlideViewBodyHeight }}
          >
            <div className='contruction-detail-view'>
              <div className='contruction-detail-view__sidemenu'>
                <PartnerNaviList
                  isSelectedBasicInfomation
                  selectedPartnerCompanyId={this.selectedCompanyId}
                  expirationCompany={this.state.expirationCompany}
                />
              </div>
              <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                {!this.isOwnCompany && (
                  <div style={{ padding: '10px 20px 0' }}>
                    <button className='btn-text--sm' onClick={this.goBack}>
                      <i className='i-back--blue i-2x vertical-middle' />
                      代行先一覧
                    </button>
                  </div>
                )}
                <div className='contruction-detail-view__menu-dropdown'>
                  <span className='construction-detail-view__button'>
                    <button className='btn' onClick={this.onClickEditButton}>
                      編集
                    </button>
                  </span>
                </div>
                <div className='contruction-detail-view__bar' />
                <div className='contruction-detail-view__main contruction-detail-view__main--fix contruction-detail-view__main--fixed'>
                  <FormList>
                    <FormListSubHeader
                      title='基本情報'
                      ccusComponent={
                        this.state.ccusCompanyData && <CcusTitleBlock />
                      }
                      noMarginTop={true}
                    />
                    <PartnerCompanyForm
                      values={this.state.formValues}
                      users={this.state.users}
                      userCompany={this.selectedCompanyId}
                      events={{}}
                      messages={{}}
                      readOnly
                      image={this.state.icon_image_url}
                      isCommonHojin={this.state.isCommonHojin}
                    />
                  </FormList>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/CompanyPreview.jsx